var map = {
	"./Home": [
		47395,
		4431,
		6354
	],
	"./Home.tsx": [
		47395,
		4431,
		6354
	],
	"./error/ErrorBoundary": [
		20488
	],
	"./error/ErrorBoundary.tsx": [
		20488
	],
	"./error/NotFound": [
		14618,
		5786
	],
	"./error/NotFound.tsx": [
		14618,
		5786
	],
	"./layouts/Footer": [
		97469
	],
	"./layouts/Footer.tsx": [
		97469
	],
	"./layouts/Header": [
		31873
	],
	"./layouts/Header.tsx": [
		31873
	],
	"./layouts/MainLayout": [
		73723
	],
	"./layouts/MainLayout.tsx": [
		73723
	],
	"./views/Agreement": [
		14938,
		4597
	],
	"./views/Agreement.tsx": [
		14938,
		4597
	],
	"./views/BattlePass": [
		50502,
		7283,
		8422,
		4431,
		9583
	],
	"./views/BattlePass.tsx": [
		50502,
		7283,
		8422,
		4431,
		9583
	],
	"./views/Blog": [
		61003,
		7283,
		1699,
		7108,
		8987,
		7952,
		2123,
		596
	],
	"./views/Blog.tsx": [
		61003,
		7283,
		1699,
		7108,
		8987,
		7952,
		2123,
		596
	],
	"./views/Contacts": [
		31657,
		2481
	],
	"./views/Contacts.tsx": [
		31657,
		2481
	],
	"./views/Contract": [
		3081,
		7070
	],
	"./views/Contract.tsx": [
		3081,
		7070
	],
	"./views/Event": [
		61678,
		4431,
		8278,
		8537
	],
	"./views/Event.tsx": [
		61678,
		4431,
		8278,
		8537
	],
	"./views/Faq": [
		55784,
		6898
	],
	"./views/Faq.tsx": [
		55784,
		6898
	],
	"./views/Giveaway": [
		92640
	],
	"./views/Giveaway.tsx": [
		92640
	],
	"./views/LiveTrades": [
		13674,
		7712
	],
	"./views/LiveTrades.tsx": [
		13674,
		7712
	],
	"./views/Odds": [
		79153,
		263,
		309
	],
	"./views/Odds.tsx": [
		79153,
		263,
		309
	],
	"./views/Pay": [
		38329,
		8220
	],
	"./views/Pay.tsx": [
		38329,
		8220
	],
	"./views/Play": [
		1943,
		4431,
		8278,
		1794
	],
	"./views/Play.tsx": [
		1943,
		4431,
		8278,
		1794
	],
	"./views/Post": [
		40156,
		7283,
		1699,
		7108,
		8987,
		7952,
		2123,
		4847
	],
	"./views/Post.tsx": [
		40156,
		7283,
		1699,
		7108,
		8987,
		7952,
		2123,
		4847
	],
	"./views/PrivacyPolicy": [
		46207,
		6630
	],
	"./views/PrivacyPolicy.tsx": [
		46207,
		6630
	],
	"./views/Profile": [
		81548,
		2876,
		8986
	],
	"./views/Profile.tsx": [
		81548,
		2876,
		8986
	],
	"./views/ProvablyFair": [
		47622,
		263,
		9039
	],
	"./views/ProvablyFair.tsx": [
		47622,
		263,
		9039
	],
	"./views/Refunds": [
		77063,
		1611
	],
	"./views/Refunds.tsx": [
		77063,
		1611
	],
	"./views/Reviews": [
		32502,
		7283,
		4719
	],
	"./views/Reviews.tsx": [
		32502,
		7283,
		4719
	],
	"./views/Search": [
		44337,
		4431,
		7543
	],
	"./views/Search.tsx": [
		44337,
		4431,
		7543
	],
	"./views/Settings": [
		35370,
		4097
	],
	"./views/Settings.tsx": [
		35370,
		4097
	],
	"./views/Upgrade": [
		17408,
		1699,
		1752,
		9775
	],
	"./views/Upgrade.tsx": [
		17408,
		1699,
		1752,
		9775
	],
	"./views/User": [
		56052,
		2876,
		2775
	],
	"./views/User.tsx": [
		56052,
		2876,
		2775
	],
	"./views/Wheel": [
		29626,
		2370
	],
	"./views/Wheel.tsx": [
		29626,
		2370
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 98463;
module.exports = webpackAsyncContext;